import React from "react";
import { NavLink } from "react-router-dom";
import usePermissions from "../../../hooks/usePermissions";
import "../../../components/ui/PageTabs.css";

/**
 * Tabs shared by the import screens, so the four pages read as one place:
 * one kind of data, new employees (workbook), workbook columns, history.
 */
const ImportTabs = () => {
  const { companyWide } = usePermissions();
  const tabs = [
    companyWide("data-tools") && {
      to: "/admin/import",
      icon: "bi-table",
      label: "Import data",
    },
    companyWide("employees", "modify") && {
      to: "/employee/import",
      icon: "bi-people",
      label: "New employees (workbook)",
      end: false,
    },
    companyWide("data-tools") && {
      to: "/admin/data-mapping",
      icon: "bi-arrow-left-right",
      label: "Workbook columns",
    },
    companyWide("data-tools") && {
      to: "/importLogs",
      icon: "bi-clock-history",
      label: "History",
    },
  ].filter(Boolean);
  if (tabs.length < 2) return null;
  return (
    <nav className="page-tabs" aria-label="Import">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.end !== false}>
          <i className={`bi ${t.icon} me-1`}></i>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default ImportTabs;
